module.exports = __webpack_public_path__ + "static/feature_fiber-9cb4ddf039ed403d9ce865ebcbee63b4.png";